import React from 'react';

const ValueTile = ({ icon, title, value, className = '' }) => {
  return (
    <div
      className={`bg-white dark:bg-shoorah-darkBgTabColor rounded-lg shadow p-6 flex items-center gap-4 ${className}`}
    >
      {/* Icon Container */}
      <div className="flex-shrink-0 w-12 h-12 bg-blue-50 dark:bg-blue-900/20 rounded-full flex items-center justify-center">
        {icon}
      </div>

      {/* Content */}
      <div className="flex flex-col">
        <span className="text-sm text-gray-600 dark:text-gray-400 font-normal">{title}</span>
        <span className="text-2xl font-semibold text-gray-900 dark:text-white">
          {value?.toLocaleString() || value}
        </span>
      </div>
    </div>
  );
};

export default ValueTile;
